import React from 'react';
import usePrices from '../../hooks/usePrices';
import { PAGES } from '../../site/routes';
import { FAQ, faqJsonLd } from '../../site/content';
import { usePageSeo, Breadcrumbs, PageHeader, Section, ComparisonTable, FaqList, LinkCards, CtaBand } from '../../site/ui';

const BREADCRUMBS = [
  { label: 'Accueil', to: PAGES.home },
  { label: 'Comparatif TryAndJudge', to: PAGES.comparison },
];

export default function ComparisonPage() {
  const { servers, updatedAt } = usePrices();

  usePageSeo({
    title: 'AV Kamas vs TryAndJudge : comparatif des prix Kamas | AV Kamas',
    description: "Comparatif des prix Kamas entre AV Kamas et TryAndJudge sur les 20 serveurs Dofus : achat moins cher et vente mieux payée, mis à jour automatiquement.",
    path: PAGES.comparison,
    breadcrumbs: BREADCRUMBS,
    jsonLd: [faqJsonLd([FAQ[3]])],
  });

  return (
    <main className="bg-gray-950 text-white">
      <Breadcrumbs items={BREADCRUMBS} />
      <PageHeader
        kicker="Comparatif des prix"
        title={<>AV Kamas vs TryAndJudge : <span className="text-yellow-400">comparatif des prix</span></>}
        intro="Vous hésitez entre AV Kamas et TryAndJudge ? Voici la comparaison serveur par serveur, calculée automatiquement à partir des prix publiés sur les sites d'achat et de vente de TryAndJudge."
      />
      <Section className="pt-0 md:pt-0">
        <ComparisonTable servers={servers} updatedAt={updatedAt} />
      </Section>
      <Section title="Comment sont calculés nos prix ?" className="bg-gray-900/40">
        <FaqList items={[FAQ[3]]} />
      </Section>
      <Section title="Commander au meilleur prix">
        <LinkCards
          links={[
            { to: PAGES.prices, title: 'Prix des Kamas', text: 'Tous nos tarifs du jour, serveur par serveur.' },
            { to: PAGES.buyGuide, title: 'Achat Kamas Maroc', text: 'Acheter vos Kamas en dirhams, étape par étape.' },
            { to: PAGES.sellGuide, title: 'Vente Kamas Maroc', text: 'Vendre vos Kamas et être payé par virement.' },
          ]}
        />
      </Section>
      <CtaBand />
    </main>
  );
}
